import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import * as React from "react";

import { PAGE_TYPE } from "@faire/retailer/consts/PAGE_TYPE";
import { ILeanProductTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";

export interface LayoutElementRendererData {
  layoutElement: ILayoutElement;
  requestId: string;
  onItemClick?: (
    containerName: string,
    requestId: string,
    token: string
  ) => void;
  onCTAClick?: (containerName: string, requestId: string) => void;
  onVisible?: (
    containerName: string,
    requestId: string,
    tokens: string
  ) => void;
  pageType?: PAGE_TYPE;
  productTileActions?: {
    onQuickAdd?: (
      product?: ILeanProductTile.ILeanProduct,
      onClickEventName?: string,
      newQuantity?: number
    ) => void;
    onChooseOption?: (
      product?: ILeanProductTile.ILeanProduct,
      onClickEventName?: string
    ) => void;
    onChooseOptionQuantityUpdate?: (
      product?: ILeanProductTile.ILeanProduct,
      onClickEventName?: string,
      newQuantity?: number
    ) => void;
    onClickHeart?: (
      product?: ILeanProductTile.ILeanProduct,
      onClickEventName?: string
    ) => void;
    onSaveToBoard?: (
      product?: ILeanProductTile.ILeanProduct,
      onClickEventName?: string,
      boardToken?: string
    ) => void;
    onRemoveFromBoard?: (
      product?: ILeanProductTile.ILeanProduct,
      onClickEventName?: string,
      boardToken?: string
    ) => void;
  };
  useLazyImageLoading?: boolean;
}

export namespace LayoutElementRendererData {
  export const build = (
    partial?: Partial<LayoutElementRendererData> | undefined
  ): LayoutElementRendererData => ({
    layoutElement: ILayoutElement.build(partial?.layoutElement),
    requestId: partial?.requestId ?? "",
    onItemClick: partial?.onItemClick,
    onCTAClick: partial?.onCTAClick,
    onVisible: partial?.onVisible,
    pageType: partial?.pageType,
    productTileActions: partial?.productTileActions,
  });
}

export const Context = React.createContext<LayoutElementRendererData>(
  LayoutElementRendererData.build()
);

export const LayoutElementProvider: React.FC<
  React.PropsWithChildren<LayoutElementRendererData>
> = (props) => {
  return <Context.Provider value={props}>{props.children}</Context.Provider>;
};
